import React from 'react';
import { Accordion } from 'react-bootstrap';

const FaqGekas = () => {
  return (
    <div className="container py-5 text-light">
      <style>
        {`
          .gekas-accordion .accordion-item {
            border: none;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 16px;
            background: linear-gradient(145deg, #1e1e2f, #2d2d44);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          
          .gekas-accordion .accordion-item:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 25px rgba(0, 0, 0, 0.35);
          }
          
          .gekas-accordion .accordion-header {
            background: transparent;
          }
          
          .gekas-accordion .accordion-button {
            background: linear-gradient(to right, #2c2c54, #40407a);
            color: #f7f7f7;
            font-weight: 600;
            font-size: 1.1rem;
            padding: 20px;
            border: none;
            box-shadow: none !important;
            transition: all 0.3s ease;
          }
          
          .gekas-accordion .accordion-button:not(.collapsed) {
            background: linear-gradient(to right, #40407a, #546de5);
            color: #ffffff;
          }
          
          .gekas-accordion .accordion-button::after {
            filter: invert(1);
            transition: transform 0.4s ease;
          }
          
          .gekas-accordion .accordion-button:not(.collapsed)::after {
            transform: rotate(180deg);
          }
          
          .gekas-accordion .accordion-body {
            background: rgba(30, 30, 47, 0.9);
            padding: 20px;
            color: #e0e0ff;
            animation: fadeIn 0.4s ease-out;
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          .gekas-accordion .accordion-button:hover {
            background: linear-gradient(to right, #40407a, #546de5);
          }
        `}
      </style>

      <h2 className="text-center mb-4" style={{ 
        fontSize: '2.5rem',
        fontWeight: 700,
        textShadow: '0 2px 10px rgba(0,0,0,0.3)',
        marginBottom: '2rem',
        background: 'linear-gradient(to right, #aaa, #fff)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}>
        Foire Aux Questions (FAQ)
      </h2>
      
      <Accordion defaultActiveKey="0" className="gekas-accordion">
        {[
          {
            q: "Quels types de services propose GEKAS ?",
            a: "GEKAS propose des services de protection rapprochée, sécurité résidentielle et industrielle, surveillance minière, transport sécurisé et conseil en sûreté."
          },
          {
            q: "Vos agents sont-ils formés ?",
            a: "Oui, nos agents suivent des formations complètes : sécurité, gestion de crises, premiers secours, et respect des normes légales."
          },
          {
            q: "Proposez-vous des services en dehors de Kinshasa ?",
            a: "Oui. Nous sommes présents à Kinshasa, Kolwezi, Lubumbashi, Likasi, Goma, Bukavu, Matadi, Isiro et Kalemie. Nos services couvrent toute la RDC."
          },
          {
            q: "Vos services sont-ils personnalisables ?",
            a: "Oui, chaque prestation est conçue sur mesure selon vos besoins, après une évaluation des risques."
          },
          {
            q: "Puis-je engager GEKAS pour un événement temporaire ?",
            a: "Tout à fait. Nous assurons la sécurité d'événements ponctuels : conférences, concerts, visites officielles, etc."
          },
          {
            q: "Quel type d'équipement utilisez-vous ?",
            a: "Nous utilisons du matériel moderne : GPS, radios sécurisées, alarmes, vidéosurveillance, véhicules de patrouille, et blindés selon les besoins."
          },
          {
            q: "Comment obtenir un devis ?",
            a: "Contactez-nous via notre site, par téléphone ou WhatsApp. Un expert vous répondra rapidement avec un devis gratuit et personnalisé."
          }
        ].map((item, index) => (
          <Accordion.Item key={index} eventKey={String(index)}>
            <Accordion.Header>{item.q}</Accordion.Header>
            <Accordion.Body>{item.a}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default FaqGekas;